import * as React from 'react';

import './linear-progress.css';

interface LinearProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  progress: number;
  progressText: string;
  /** Shows `progressText` even at 100%, for a form holding an unsaved edit. */
  needsAttention?: boolean;
}

const LinearProgress = React.forwardRef<HTMLDivElement, LinearProgressProps>(
  ({ progress, progressText, needsAttention = false, ...props }, ref) => {
    return (
      <div className="linear-progress" ref={ref} {...props}>
        <div className="linear-progress-value">{progress}% Completed</div>
        {progress < 100 || needsAttention ? (
          <div className="linear-progress-text">{progressText}</div>
        ) : (
          <div className="linear-progress-text-completed">All done!</div>
        )}
        <progress className="linear-progress-var" max="100" value={progress} />
      </div>
    );
  },
);

export { LinearProgress };
